import React from 'react';
import { ActivityIndicator } from 'react-native';
import Modal from 'react-native-modal';
import { useAppSelector } from 'src/common/hooks';
import { Container, RegularText, SizedBox } from 'src/components';
import { descriptionSelector, isVisibleSelector, titleSelector } from 'src/redux/loadingModal/LoadingModalSlice';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

export const LoadingModalHOC = ({ children }: React.PropsWithChildren<any>) => {
  const isVisible = useAppSelector(isVisibleSelector);
  const title = useAppSelector(titleSelector);
  const description = useAppSelector(descriptionSelector);

  return (
    <>
      {children}
      <Modal animationIn="bounceIn" animationOut="bounceOut" isVisible={isVisible}>
        <Container
          width="100%"
          borderRadius={metrics.borderRadius}
          paddingHorizontal={metrics.large}
          paddingVertical={metrics.huge}
          backgroundColor="white">
          <ActivityIndicator color={AppColors.primary} size={pixelScaler(60)} />
          <SizedBox />
          <RegularText textAlign="center" fontWeight="bold" fontSize="larger">
            {title}
          </RegularText>
          <SizedBox />

          <RegularText textAlign="center">{description}</RegularText>
        </Container>
      </Modal>
    </>
  );
};
